import Vue from "vue";
import axios from "axios";
import { API_ADMIN_URL, API_GAEL_URL } from "@/common/config";
import store from "@/store";
import { UPDATE_TOKEN } from "@/store/actions/actions.type";
import { isDevBypassActive } from "@/common/keycloakStub";
import msg from "@/common/msg.util";

const ApiAdmin = {
  apiAdminAxios: null,
  init() {
    return new Promise(resolve => {
      this.apiAdminAxios = axios.create({
        baseURL: API_ADMIN_URL,
        headers: { "Content-Type": "application/json" }
      });

      this.apiAdminAxios.interceptors.response.use(
        this.responseInterceptor.bind(this),
        this.errorInterceptor.bind(this)
      );

      resolve();
    });
  },

  responseInterceptor(response) {
    return response;
  },

  errorInterceptor(error) {
    const that = this;

    if (!error.response || error.response.status !== 401) {
      return Promise.reject(error);
    }

    if (isDevBypassActive(store)) {
      return Promise.reject(error);
    }

    if (
      !store.getters["auth/keycloak"].token ||
      !store.getters["auth/keycloak"].refreshToken
    ) {
      return new Promise((resolve, reject) => {
        store.getters["auth/keycloak"].logout();
        reject(error);
      });
    }

    return new Promise((resolve, reject) => {
      store
        .dispatch(`auth/${UPDATE_TOKEN}`)
        .then(() => {
          that.setTokenHeader(store.getters["auth/keycloak"].token);
          const config = error.config;
          config.headers[
            "Authorization"
          ] = `Bearer ${store.getters["auth/keycloak"].token}`;
          that.apiAdminAxios
            .request(config)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
        })
        .catch(e => {
          msg.alert(
            "Login expirado devido inatividade. Realize o login novamente",
            { dismissible: true, type: "warning" }
          );
        });
    });
  },

  setTokenHeader(token) {
    this.apiAdminAxios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${token}`;
  },

  setSelectedGroupHeader(group) {
    this.apiAdminAxios.defaults.headers.common["Group"] = group;
  },

  query(resource, params) {
    return this.apiAdminAxios.get(resource, { params: { ...params } });
  },

  getPdf(resource, params) {
    return this.apiAdminAxios.get(resource, {
      params: { ...params },
      responseType: "blob"
    });

    // return this.apiAdminAxios.get(resource, {
    //   params: { ...params }
    // });
  },

  get(resource, slug = "") {
    const path = slug ? `${resource}/${slug}` : resource;
    return this.apiAdminAxios.get(path);
  },

  post(resource, params) {
    return this.apiAdminAxios.post(`${resource}`, params);
  },

  put(resource, slug, params) {
    return this.apiAdminAxios.put(`${resource}/${slug}`, params);
  },

  // put(resource, params) {
  //   return this.apiAdminAxios.put(`${resource}`, params);
  // },

  delete(resource, slug) {
    return this.apiAdminAxios.delete(`${resource}/${slug}`);
  }
};

export default ApiAdmin;
